import koUI from '@linktivity/link-ui/lang/ko';
import country from '@link/share/i18n/country/ko';

import japanPrefectures from '@link/share/i18n/japanPrefectures/ko';
import {
  NotificationType,
  PaymentType,
  PaymentPeriod,
  BookingType,
  IssuedStatus,
  CancelReason,
  ConfirmationType,
  DiscrepancyType,
  DiscrepancyReason,
  DiscrepancyStatus,
  DiscrepancyWaitingStatus,
  DiscrepancyInitiator,
  NotificationMethod,
  WalletOrderStatus,
  TransactionTypeMap
} from '@link/share/services/const';

export default {
  ...koUI,
  country,
  japanPrefectures,
  common: {
    account: '계정',
    signOut: '로그아웃',
    status: '상태',
    action: '작업',
    parenthesis: '({{text}})',
    detail: '상세',
    edit: '편집',
    add: '추가',
    save: '저장',
    or: '또는',
    delete: '삭제',
    formTitle: '{{id}} ({{title}})',
    withSpace: '{{val1}} {{val2}}',
    withDashSeparated: '{{val1}} - {{val2}}',
    withSlashSeparated: '{{val1}} × {{val2}}',
    withCommaSeparated: '{{val1}} / {{val2}}',
    slash: '/',
    confirm: '확정',
    editConfirm: '편집 내용 확인',
    ON: '켬',
    OFF: '끔',
    cancel: '취소',
    confirmDelete: '{{name}}을 삭제하시겠습니까?',
    yes: '예',
    no: '아니오',
    close: '닫기',
    has: '있음',
    hasNot: '없음',
    verify: '확인',
    register: '등록',
    continueEditing: '편집 계속',
    leaveCurrentPage: '이 페이지에서 나가기',
    leaveCurrentPageConfirm: '{{name}}은 아직 편집 중입니다',
    separator: ', ',
    pdf: 'PDF',
    mobile: '모바일',
    rangeSymbol: '~',
    pc: 'PC',
    grossPrice: '판매 가격',
    netPrice: '도매가',
    sender: '발신자',
    approver: '승인자',
    discrepancy: '차액 조정 내용',
    adjustmentAmount: '조정 금액',
    commission: '커미션',
    cancelFee: '취소 수수료',
    refundAmount: '환불 금액',
    arrow: '→',
    colon: ':',
    empty: '데이터 없음',
    viewDetail: '상세 보기',
    voucher: '바우처',
    printableVoucher: '인쇄용',
    forDisplayVoucher: '표시용',
    supplier: '공급사',
    agent: 'OTA',
    complete: '완료',
    denied: '거부',
    downloadDetails: '명세서 다운로드',
    total: '검색 결과·{{total}}건',
    infoSent: '정보는 {{target}}로 전송되었습니다',
    currency: '통화',
    zip: 'ZIP',
    excel: 'CSV',
    download: '다운로드',
    manual: '매뉴얼'
  },
  views: {
    contractsList: {
      title: '판매 권한 설정 현황',
      supplier: '공급사(ID)',
      agent: 'OTA(ID)',
      systemChargePercent: '현재 시스템 수수료(%)',
      supplierCountry: '공급사(국가·지역)',
      agentCountry: 'OTA(국가·지역)'
    },
    contractDetail: {
      addTitle: '계약 추가',
      editTitle: '계약 편집',
      title: '계약 상세',
      form: {
        supplier: '공급사',
        agent: 'OTA',
        status: '상태',
        systemChargePercent: '현재 시스템 수수료(%)'
      }
    },
    suppliersList: {
      supplierCustomId: '공급사(ID)'
    },
    suppliersDetail: {
      title: '회사 정보',
      supplierCustomId: '공급사(ID)',
      originalName: '공급사명',
      englishName: '공급사(영문명)',
      status: '상태',
      mainLanguage: '이용 언어',
      salesAccounts: '영업 담당',
      webUrl: '공식 URL',
      countryCode: '국가·지역',
      categories: '카테고리',
      registrationCode: '적격 청구서 발행 사업자 등록번호',
      logoUrl: '로고',
      privacyPolicyType: '개인정보처리방침 처리',
      currency: '이용 통화',
      transferFeePayer: '송금 수수료 결제',
      billingMethod: '정산 방식',
      systemFeeRefundPolicyCustomer: '시스템 이용료 환불(고객 취소)',
      systemFeeRefundPolicySupplier: '시스템 이용료 환불(공급사 취소)',
      systemFeeRefundPolicyInvalid: '시스템 이용료 환불(무효화 처리)'
    },
    suppliersAccount: {
      title: '계정 관리',
      role: '역할',
      supplierCustomId: '공급사',
      loginId: '이메일 주소',
      username: '유저명',
      supportLanguages: '이용 언어'
    },
    suppliersAccountDetail: {
      addTitle: '계정 추가',
      editTitle: '계정 편집',
      supplierId: '공급사',
      loginId: '이메일 주소(로그인 ID)',
      password: '비밀번호',
      supportLanguages: '이용 언어',
      role: '역할',
      notificationType: '알림 유형',
      username: '유저명',
      phoneNumber: '전화번호',
      personInCharge: '담당자명',
      department: '부서·직급',
      receiveNotifications: '알림 수신',
      notificationMethod: '알림 수신 방법',
      requireMfa: '2단계 인증'
    },
    newAgent: {
      otaCustomId: 'OTA ID',
      title: 'OTA 추가',
      originalName: 'OTA명',
      englishName: 'OTA명(EN)',
      contractType: '서명된 계약',
      mainLanguage: '주요 언어',
      salesAccounts: '영업 담당',
      webUrl: '공식 URL',
      country: '국가·지역',
      currency: '이용 통화',
      logoUrl: '로고',
      paymentType: '결제 방법',
      paymentPeriod: '결제 사이클'
    },
    agentAccountList: {
      role: '역할',
      org: '소속 그룹',
      loginId: '유저 ID',
      username: '유저명',
      supportLanguages: '이용 언어'
    },
    newAgentAccount: {
      title: '신규 계정 추가',
      otaId: 'OTA',
      otaOrgId: '소속 그룹',
      loginId: '이메일 주소(로그인 ID)',
      password: '비밀번호',
      role: '역할',
      supportLanguages: '이용 언어',
      notificationType: '알림 유형',
      username: '유저명',
      phoneNumber: '전화번호',
      personInCharge: '담당자명',
      department: '부서·직급',
      requireMfa: '2단계 인증'
    },
    orgList: {
      country: '국가·지역',
      parentOtaOrg: '상위 그룹',
      otaOrgName: '그룹명'
    },
    newOrg: {
      title: '그룹 추가',
      otaOrgCustomId: '그룹 ID',
      otaOrgName: '그룹명',
      otaId: 'OTA',
      otaOrgId: '그룹 ID',
      parentOtaOrgId: '상위 그룹',
      countryCode: '국가·지역',
      logoUrl: '로고',
      activityIdWhitelist: '상품 판매 설정'
    },
    login: {
      title: 'GDS에 오신 것을 환영합니다',
      email: '이메일 주소',
      password: '비밀번호',
      button: '로그인',
      success: '로그인되었습니다',
      link: '비밀번호를 잊으신 분은 여기를 클릭하세요',
      resettitle: '비밀번호 재설정',
      reset: '비밀번호 재설정 메일 전송',
      send: '비밀번호 재설정용 URL을 {{email}}로 전송했습니다. 메일을 확인 후 비밀번호를 재설정해 주세요',
      resetError: '이메일을 보내지 못했습니다. 나중에 다시 시도해 주세요.',
      googleLogin: 'Google 계정으로 로그인',
      register: '신규 등록·문의는 여기',
      privacy: '개인정보처리방침',
      ipNotAllowed: '네트워크 오류가 발생했습니다. 다시 시도해 주세요.'
    },
    enrollOTP: {
      title: '이중 인증 설정',
      description:
        '계정 보안을 강화하기 위해 인증 앱으로 QR 코드를 스캔해 주세요',
      step1: '1. 스마트폰에 Google Authenticator 설치',
      appStore: 'App Store (iOS)',
      googlePlay: 'Google Play (Android)',
      step2: '2. QR 코드 스캔',
      step3: '3. 표시된 6자리 코드를 입력하면 완료',
      qrLabel: 'QR 코드',
      codeLabel: '인증 앱의 6자리 코드',
      submit: '확인 및 활성화',
      enrollError: '인증 코드가 올바르지 않습니다. 다시 시도해 주세요'
    },
    verifyOTP: {
      title: '이중 인증',
      code: '인증 코드',
      verify: '확인',
      verifyError: '인증 코드가 올바르지 않습니다. 다시 시도해 주세요'
    },
    changePassword: {
      title: '비밀번호 변경',
      oldPassword: '현재【비밀번호】',
      newPassword: '새【비밀번호】'
    },
    booking: {
      bookingCustomId: '예약번호',
      status: '상태',
      purchasedDate: '신청일',
      participationDate: '참가일',
      freeSale: '프리세일',
      participationTime: '시작 시간',
      activityTitleSupplierLang: '상품',
      planTitle: '플랜',
      orderCount: '수량',
      firstName: '참가자 이름',
      participantResidentRegion: '참가자 거주 국가·지역',
      participantEmailAddress: '참가자 이메일',
      destinationEmail: '연락처 정보',
      agentReservationNote: 'OTA 예약 번호',
      agentBookingIdRemark: '여행사 예약 번호 (비고)',
      agentReservationSpecialNote: '여행사 예약 특기 사항',
      supplierBookingId: '공급사 예약번호',
      bookingDetail: '예약 상세',
      bookingNumber: '예약번호',
      parentBookingNumber: '관련 예약 번호',
      bookingType: '구매 구분',
      applicationDate: '신청일',
      bookingStatus: '예약 상태',
      cancelledBySupplier: '공급사 처리',
      issuedStatus: '이용 상태',
      bookerName: '예약 대표자 성명',
      product: '상품/플랜',
      productVoucherLang: '상품/플랜(예약 언어)',
      voucherExpiration: '바우처 유효기간',
      paymentInfo: '결제 정보',
      salePrice: '판매 가격',
      commission: '커미션',
      netPrice: '도매가',
      free: '프리세일',
      individual: '개별',
      download: '다운로드',
      exchangeUrl: '교환용 URL',
      openUrl: 'URL 열기',
      discrepancies: '차액 조정',
      cancelBooking: '예약 취소',
      invalidBookingBtn: '예약 무효화',
      invalidBooking: '이 예약은 취소가 아닌 거부가 필요합니다',
      invalidBookingConfirmP1: '선택한 예약을 무효화하시겠습니까?',
      invalidBookingConfirmP2: '이 차액 조정 항목을 승인하시겠습니까?',
      invalidBookingConfirmP3:
        '무효화 후 정산서 반영 방법은 다음 단계에서 선택할 수 있습니다',
      invalidBookingConfirmText: '무효화',
      invalidBookingConfirmProcessing:
        '현재 처리 중인 예약입니다. 그래도 무효화하시겠습니까?',
      invalidBookingSecondTitle: '정산서 반영 방법 선택',
      invalidBookingOpt1Title:
        '1. 예약 확정일이 속한 월(또는 주)의 정산서에 반영',
      invalidBookingOpt1P1:
        '해당 예약의 예약 확정일이 속한 월(또는 주)의 정산서에 전액 환불 처리로 반영됩니다.',
      invalidBookingOpt1P2:
        '무효화 실행 일시가 해당 예약의 예약 확정일이 속한 월(또는 주)의 정산 마감일을 지나 정산서가 이미 발행된 경우, 해당 월(또는 주)의 정산서가 재발행됩니다.',
      invalidBookingOpt1P3:
        '무효화 처리 완료 후에는 반드시 최신 버전의 정산서를 다시 다운로드하여 확인해 주세요.',
      invalidBookingOpt1P4: '또한, 해당 예약 정보는',
      invalidBookingOpt1P5:
        '무효화 실행 일시가 속한 월(또는 주)의 정산서에는 표시되지 않습니다.',
      invalidBookingOpt2Title:
        '2. 무효화 실행 일시가 속한 월(또는 주)의 정산서에 반영',
      invalidBookingOpt2P1:
        '해당 예약의 무효화 실행 일시가 속한 월(또는 주)의 정산서에 전액 환불 처리로 반영됩니다.',
      invalidBookingOpt2P2:
        '무효화 실행 일시가 해당 예약의 예약 확정일이 속한 월(또는 주)의 정산 마감일을 지나 정산서가 이미 발행된 경우에도 정산서는 재발행되지 않습니다.',
      cancelFeeAndRefundAmount: '취소 수수료 및 환불 금액',
      currentDateTime: '현재 날짜·시간',
      amount: '금액',
      paidAmount: '결제 금액',
      cancelFee: '취소 수수료',
      refundAmount: '환불 금액',
      confirmedBy: '확인자명',
      performCancel: '취소 실행',
      cancelResult: '취소 완료',
      cancelSucceed: '취소가 완료되었습니다',
      cancelPending: '취소 처리 중입니다. 공급업체의 응답을 기다리고 있습니다.',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}} 추가 예약 정보',
      cancelReason: '취소 완료',
      cancelComment: '취소 코멘트',
      denyReason: '거부 사유',
      name: '{{firstName}} {{lastName}}',
      otaName: '판매자',
      endUserRefundAmount: '엔드 유저 환불 금액',
      paymentRefundAmount: '결제 환불 금액',
      cancelFeeFromTravelerToAgent: '취소 수수료（여행자에서 대리점으로）',
      cancelFeeFromAgentToLink: '취소 수수료（대리점에서 LINKTIVITY로）',
      finalSettlementToLink: '최종 정산 금액（LINKTIVITY로）',
      paymentRefundAmountOta: '결제 환불 금액（여행사）',
      cancelFeeFromLinkToSupplier: '취소 수수료（LINKTIVITY에서 공급사로）',
      systemCharge: '시스템 요금',
      finalSettlementFromLink: '최종 정산 금액（LINKTIVITY로부터）',
      linkCancelFee: '취소 수수료（LINKTIVITY 수금분）',
      linkRevenue: 'LINKTIVITY 수익'
    },
    discrepancies: {
      title: '차액 조정 요청 {{type}}',
      finished: '전송 완료',
      return: '예약 상세로 돌아가기',
      send: '전송',
      receive: '수신',
      discrepancy: '차액 조정',
      discrepancyType: '조정 내용',
      reasonDescription: '상세',
      reason: '사유',
      priceAdjust: '조정 금액(차액)',
      grossAdjustmentAmount: '판매 가격',
      netAdjustmentAmount: '도매가',
      addItem: '항목 추가',
      bookingInfo: '예약 정보',
      adjustmentItem: '조정 항목',
      verifier: '확인자명',
      applicant: '신청자',
      enterName: '이름을 입력해 주세요',
      apply: '신청하기',
      adjustmentAmount: '조정 금액',
      originalGrossAmount: '원 판매가',
      originalNetAmount: '원 도매가',
      adjustedGrossAmount: '조정 후 판매가',
      adjustedNetAmount: '조정 후 도매가',
      requiredAmount: '금액을 입력하세요.',
      applySuccessTitle: '차액 조정 요청을 전송했습니다',
      approveSuccessTitle: '차액 조정 요청을 승인했습니다',
      denySuccessTitle: '차액 조정 요청을 거부했습니다',
      successMsg: '승인된 조정 금액은 최근 결제 월에 반영됩니다',
      alert:
        '확정 시 입력한 차액 조정 항목이 승인 요청을 위해 {{target}}로 전송됩니다',
      waitingTip:
        '아래 조정 항목을 {{target}}로 전송했습니다. 현재 {{target}}의 승인 대기 중입니다',
      reviewTip: '이 예약을 무효화하시겠습니까?',
      approve: '승인',
      deny: '거부'
    },
    bookingList: {
      title: '예약 관리',
      filter: {
        bookingCustomId: '예약번호',
        activityTitle: '상품명',
        planTitle: '플랜명',
        status: '상태',
        participantName: '예약 대표자 성명',
        participantEmail: '예약 대표자 이메일 주소',
        purchasedAtStart: '신청일',
        participateDateStart: '참가일(현지 상품)',
        agentReservationNo: 'OTA 예약번호',
        supplierBookingId: '공급사 예약번호'
      },
      participantResidentRegion: '국가·지역'
    },
    bulkBookingList: {
      title: '예약 관리',
      reservationNumber: '예약번호',
      status: '상태',
      submitDate: '제출일',
      product: '상품',
      plan: '플랜',
      agent: 'OTA'
    },
    discrepancyList: {
      title: '차액 조정',
      purchaseDate: '구매일',
      participationDate: '참가일',
      keyword: '키워드',
      activity: '상품',
      plan: '플랜',
      reservationNumber: '예약번호',
      transactionType: '거래 종류',
      adjustmentStatus: '조정 상태',
      salesPrice: '판매 가격',
      wholesalePrice: '도매가',
      sender: '발신자',
      senderFormat: '{{senderName}} ({{initiator}})'
    },
    notificationInbox: {
      title: '알림 목록',
      all: '전체 ({{count}})',
      summary: '총 {{total}}건 · 미읽음 {{unread}}건',
      empty: '알림이 없습니다',
      detailPlaceholder: '왼쪽에서 알림을 선택하여 상세 내용을 확인하세요.',
      detailLoadError: '알림 상세 정보를 가져오지 못했습니다'
    },
    invoiceChange: {
      title: '금액 조정',
      adjustmentDate: '조정일',
      adjustedBy: '조정자',
      invoiceAmount: '청구 금액',
      adjustmentAmount: '조정 금액',
      paymentAmount: '결제 금액',
      adjustmentReason: '조정 사유',
      submit: '확인',
      addFile: '파일 첨부',
      historyTitle: '금액 조정 내역',
      finalAmount: '조정 후 결제 금액'
    }
  },
  const: {
    cancelErrorCode: {
      BOOKING_NOT_FOUND: '예약을 찾을 수 없습니다',
      BOOKING_ALREADY_CANCELLED: '이미 취소되었습니다',
      CANCEL_DEADLINE_PASSED: '취소 기간이 지났습니다',
      BOOKING_ALREADY_ISSUED: '이 예약은 이미 발권되어 취소할 수 없습니다',
      BOOKING_STATUS_NOT_CANCELLABLE:
        '이 예약은 현재 상태에서 취소할 수 없습니다',
      BOOKING_INVALIDATION_IN_PROGRESS:
        '이 예약은 무효화 처리 중이므로 취소할 수 없습니다',
      BOOKING_DECLINE_INSTEAD_OF_CANCEL:
        '이 예약은 취소가 아닌 거절 처리가 필요합니다',
      BOOKING_NOT_CANCELLABLE: '이 예약은 취소할 수 없습니다',
      CANCEL_NOT_STARTED: '취소 절차가 시작되지 않았습니다',
      CANCEL_REFUND_CHANGED: '취소 수수료 또는 환불 금액이 변경되었습니다',
      BOOKING_ADAPTER_BOOKING_NOT_CANCELLABLE: '공급업체가 취소를 거부했습니다',
      BOOKING_ADAPTER_EXTERNAL_FAILED: '공급업체가 취소를 거부했습니다',
      BOOKING_ADAPTER_EXTERNAL_PENDING:
        '공급업체의 확인을 기다리고 있습니다. 잠시 후 다시 시도해 주세요',
      RETRYABLE: '잠시 후 다시 시도해 주세요',
      UNKNOWN: '이 예약은 취소할 수 없습니다'
    },
    cancelDeadline: '취소 기한: {{deadline}}',
    language: {
      JAPANESE: '일본어',
      ENGLISH: '영어',
      CHINESE: '중국어(간체)',
      CHINESE_T: '중국어(번체)',
      KOREAN: '한국어'
    },
    partnerCategory: {
      RAILWAY: '철도',
      BUS: '버스',
      FERRIES: '페리',
      RENTAL_CAR: '렌터카',
      SIGHTSEEING_SPOT: '관광 명소',
      FOOD: '레스토랑',
      EXPERIENCE: '체험',
      ACCOMMODATION: '호텔',
      TOUR: '투어',
      ACTIVITY: '액티비티',
      CHARTER: '전세',
      LINKTIVITY: 'LINKTIVITY',
      OTHERS: '기타'
    },
    privacyPolicyType: {
      EMAIL_NOT_SHOW: '고객 이메일 숨기기',
      NAME_NOT_SHOW: '고객 이름 숨기기',
      REGISTERED_CODE_NOT_SHOW: '예약번호 숨기기',
      OTA_BOOKING_ID_NOT_SHOW: '여행사 예약번호 숨기기',
      SUPPLIER_BOOKING_ID_NOT_SHOW: '투어 운영사 예약번호 숨기기'
    },
    transferFeePayer: {
      LINK: 'LINKTIVITY',
      SUPPLIER: '공급사'
    },
    billingMethod: {
      PURCHASE_DATE: '구매일',
      USAGE_DATE: '이용일'
    },
    systemFeeRefundPolicy: {
      NO_REFUND: '환불 안 함',
      ALL_REFUND: '전액 환불'
    },
    role: {
      ADMIN: '관리자',
      VIEWER: '열람자',
      EDITOR: '편집자',
      OPERATOR: '운영자'
    },
    contractType: {
      equivalent: '이용약관_V20181101 동등',
      nonEquivalent: '이용약관_V20181101 비동등'
    },
    checklistType: {
      RESTRICTION: '참가 제한',
      REQUIRED_ITEM_TO_BRING_AND_ATTIRE: '참가 시 필요 복장·소지품',
      REQUIRED_OTHER: '참가 시 필수 기타 사항',
      REQUIRED_ADDITIONAL_NOTE: '비고・기타',
      NICE_TO_HAVE_ITEM_TO_BRING_AND_ATTIRE: '추천 복장 및 준비물',
      NICE_TO_HAVE_OTHER: '기타 추천',
      INCLUDED: '포함 사항'
    },
    notificationType: {
      [NotificationType.NoNotification]: '알림 없음',
      [NotificationType.ActivityOperation]: '상품 관련',
      [NotificationType.BookOperation]: '예약 관련',
      [NotificationType.FinanceOperation]: '정산・재무 관련',
      [NotificationType.SystemOperation]: 'LINK 공지사항'
    },
    inboxCategory: {
      [NotificationType.ActivityOperation]: '상품 관련',
      [NotificationType.BookOperation]: '예약 관련',
      [NotificationType.FinanceOperation]: '정산・재무 관련',
      [NotificationType.SystemOperation]: 'LINK 공지사항',
      [NotificationType.UndefinedNotification]: '기타',
      [NotificationType.NoNotification]: '없음'
    },
    notificationMethod: {
      [NotificationMethod.UndefinedMethod]: '미정의',
      [NotificationMethod.Email]: '이메일',
      [NotificationMethod.InternalMessage]: '사이트 내 알림'
    },
    paymentType: {
      [PaymentType.PostBankTransfer]: '후불(은행 송금)',
      [PaymentType.PreLinkpay]: '사전 결제(온라인 결제)',
      [PaymentType.PostLinkpay]: '후불(LinkPay)',
      [PaymentType.PreCharge]: '사전 결제(은행 송금)'
    },
    paymentPeriod: {
      [PaymentPeriod.Weekly]: '주간',
      [PaymentPeriod.Monthly]: '월간',
      [PaymentPeriod.HalfMonthly]: '격주'
    },
    attachmentType: {
      PDF: 'PDF',
      IMAGE: '이미지'
    },
    bookingField: {
      PARTICIPANT_EMAIL_ADDRESS: '참가자 이메일',
      HOTEL_NAME: '숙박시설명',
      HOTEL_ADDRESS: '숙박시설 주소',
      HOTEL_RESERVATION_LAST_NAME: '숙박 대표자 성(姓)',
      HOTEL_RESERVATION_FIRST_NAME: '숙박 대표자 이름(名)',
      HOTEL_TEL: '숙박시설 전화번호',
      ARRIVAL_DATE: '현지 도착일',
      ARRIVAL_TIME: '도착 시각',
      ARRIVAL_FLIGHT_NUMBER: '항공 도착편명',
      DEPARTURE_DATE: '출발일',
      DEPARTURE_TIME: '출발 시각',
      DEPARTURE_FLIGHT_NUMBER: '항공 출발편명',
      DESTINATION_EMAIL: '현지 연락처(이메일)',
      DESTINATION_TEL: '현지 연락처(전화번호)',
      PARTICIPANT_RESIDENT_REGION: '참가자 거주 국가·지역',
      PARTICIPANT_LANGUAGE: '참가자 사용 언어'
    },
    extendedBookingField: {
      PASSENGERS_QUANTITY: '탑승 인원',
      PREFERRED_START_TIME: '희망 시작 시간',
      PREFERRED_PICK_UP_LOCATION: '픽업/승차 장소',
      PREFERRED_DROP_OFF_LOCATION: '하차/드롭오프 장소',
      PARTICIPANTS_QUANTITY: '참가 인원',
      LUGGAGE_QUANTITY: '여행 가방 수(합계)',
      CHILDREN_WITHOUT_SEAT_QUANTITY: '좌석 불필요 유아',
      CHILD_SEAT_QUANTITY_PAID: '카시트 이용(현장 결제)',
      CHILD_SEAT_QUANTITY_FREE: '카시트 이용(무료)',
      PREFERRED_GUIDE_LANGUAGE_CODE: '가이드 언어 요청',
      PREFERRED_DRIVER_LANGUAGE_CODE: '드라이버 언어 요청'
    },
    extendedParticipantField: {
      PASSPORT_FIRST_NAME: '참가자 이름(여권 로마자 표기)',
      PASSPORT_LAST_NAME: '참가자 성(여권 로마자 표기)',
      PASSPORT_NATIONALITY: '국적',
      PASSPORT_NUMBER: '여권 번호',
      DATE_OF_BIRTH: '생년월일',
      AGE: '나이',
      GENDER: '성별',
      EYESIGHT: '시력',
      WEIGHT_KG: '체중 (kg)',
      HEIGHT_CM: '신장(cm)',
      SHOE_SIZE_CM: '신발 사이즈(cm)',
      CLOTHES_SIZE: '의류 사이즈',
      VEGETARIAN_MEALS: '채식 희망',
      DIVING_EXPERIENCE_TIMES: '다이빙 경험 횟수(회)',
      RENTAL_EQUIPMENTS_FREE: '장비 렌탈 희망 ※무료',
      RENTAL_EQUIPMENTS_PAY_LOCALLY: '장비 렌탈 희망 ※현지 지불'
    },
    bookingStatus: {
      REQUEST_PENDING: '요청',
      REQUEST_REJECTED: '반려',
      CONFIRMED: '확정 완료',
      CANCELLED_BY_TRAVELER: '취소(고객)',
      CANCELLED_BY_SUPPLIER: '취소(공급사)',
      INVALID: '무효화',
      CANCEL_FAILED: '취소 실패',
      CANCEL_PENDING: '취소 보류 중'
    },
    bulkBookingStatus: {
      SUBMITTED: '제출 완료',
      PAID: '송금 완료',
      ACCEPTED: '승인 완료',
      QUEUED: '발행 대기 중',
      ISSUED: '발행 완료',
      PENDING: '보류 중'
    },
    bulkBookingAction: {
      SUBMIT: '제출',
      PAY: '송금',
      ACCEPT: '승인',
      PEND: '보류',
      ISSUE: '발권',
      FINISH: '완료'
    },
    confirmationType: {
      [ConfirmationType.FreeSale]: '참가일 지정(프리세일)',
      [ConfirmationType.FreeSaleOpenDate]: '참가일 지정 불필요(프리세일)',
      [ConfirmationType.Inventory]: '참가일 지정(실시간)',
      [ConfirmationType.Request]: '참가일 지정 있음(요청)'
    },
    // use for bookingDetail page
    bookingConfirmationType: {
      [ConfirmationType.FreeSale]: '프리세일',
      [ConfirmationType.FreeSaleOpenDate]: '프리세일',
      [ConfirmationType.Inventory]: '실시간',
      [ConfirmationType.Request]: '요청'
    },
    walletOrderStatus: {
      [WalletOrderStatus.StatusPending]: '미결제',
      [WalletOrderStatus.StatusPaying]: '충전 미완료',
      [WalletOrderStatus.StatusPaid]: '송금 완료',
      [WalletOrderStatus.StatusRejected]: '거부 완료',
      [WalletOrderStatus.StatusCancelled]: '취소 완료',
      [WalletOrderStatus.StatusConfirmed]: '충전 완료',
      [WalletOrderStatus.StatusRefunded]: '환불 완료'
    },
    transactionTypeMap: {
      [TransactionTypeMap.TransactionTypeCancelRefund]: '취소 완료',
      [TransactionTypeMap.TransactionTypePurchase]: '확정 완료',
      [TransactionTypeMap.TransactionTypeDiscrepancy]: '차액 조정 완료',
      [TransactionTypeMap.TransactionTypeInvalid]: '무효화 완료'
    },
    discrepancyStatus: {
      [DiscrepancyStatus.Waiting]: '승인 대기',
      [DiscrepancyStatus.Approved]: '조정 완료',
      [DiscrepancyStatus.Rejected]: '반려'
    },
    discrepancyWaitingStatus: {
      [DiscrepancyWaitingStatus.Deliver]: '승인 대기',
      [DiscrepancyWaitingStatus.Receive]: '승인 대응 대기'
    },
    discrepancyInitiator: {
      [DiscrepancyInitiator.Ota]: 'OTA',
      [DiscrepancyInitiator.Supplier]: '공급사'
    },
    discrepancyType: {
      [DiscrepancyType.Refund]: '환불',
      [DiscrepancyType.AdditionalCharge]: '추가 청구'
    },
    discrepancyReason: {
      [DiscrepancyReason.AdditionalServices]: '상품 추가 요금',
      [DiscrepancyReason.MissedServices]: '미제공으로 인한 환불',
      [DiscrepancyReason.CustomerComplaint]: '고객 불만으로 인한 환불',
      [DiscrepancyReason.DoubleCharge]: '이중 청구',
      [DiscrepancyReason.FeeForBookingChange]: '변경 수수료',
      [DiscrepancyReason.PartialCancel]: '일부 취소',
      [DiscrepancyReason.SelfAdjustment]: '개별 조정',
      [DiscrepancyReason.Other]: '기타'
    },
    bookingType: {
      [BookingType.Bulk]: '일괄 처리',
      [BookingType.Single]: '개별 처리'
    },
    issuedStatus: {
      [IssuedStatus.Issued]: '사용 완료',
      [IssuedStatus.NotIssued]: '미사용',
      [IssuedStatus.Partial]: '일부 사용',
      [IssuedStatus.Disable]: '무효'
    },
    cancelReason: {
      [CancelReason.BadWeather]: '악천후',
      [CancelReason.BookedByMistake]: '예약을 잘못하여',
      [CancelReason.DoubleBooking]: '중복 예약으로 인함',
      [CancelReason.FlightIssues]: '항공 취소·지연·변경으로 인해',
      [CancelReason.FoundCheaperRate]: '더 싼 가격을 찾았습니다.',
      [CancelReason.Other]: '기타',
      [CancelReason.ParticipantMinimumNotMet]: '최소 출발 인원 미달',
      [CancelReason.ParticipantOrDateChange]: '예약일 또는 인원 변경',
      [CancelReason.PrivateBuyout]: '단체 전세 · 만석',
      [CancelReason.SameSupplierActivityChange]:
        '동일 공급사의 다른 상품으로 변경',
      [CancelReason.SeparateSupplierActivityChange]:
        '다른 공급사의 상품으로 변경',
      [CancelReason.Sickness]: '컨디션 불량',
      [CancelReason.OtaCancelWithoutReason]: 'OTA 사유 불명 취소',
      [CancelReason.TechnicalDifficulties]: '장비 고장 또는 예기치 못한 문제'
    },
    category: {
      RAILWAY_TICKET: '철도 승차권',
      AIRPORT_TRANSPORTATION: '공항 이동',
      SHINKANSEN: '신칸센',
      EXPRESS_BUS: '고속버스',
      BUS_TOUR: '버스 투어',
      CRUISES: '페리·크루즈',
      RENTAL_CAR: '렌터카',
      CHARTER: '전세',
      ATTRACTION: '시설(입장권)',
      THEME_PARK: '테마파크',
      MUSEUM_GALLERY: '박물관·미술관',
      AQUARIUM_ZOO: '수족관·동물원',
      TEMPLES_SHINES: '사찰·신사',
      TOWER_BUILDING: '전망대·타워',
      JAPANESE_RESTAURANT: '일식 레스토랑',
      WESTERN_RESTAURANT: '서양 레스토랑',
      CHINESE_RESTAURANT: '중식 레스토랑',
      OTHER_RESTAURANT: '레스토랑(기타)',
      DESSERT_BEVERAGE: '디저트·음료',
      SIGHTSEEING_TOUR: '관광 투어',
      MARINE_SPORTS: '해양 스포츠',
      OUTDOOR_ACTIVITIES: '아웃도어 액티비티',
      ONSEN: '온천',
      SPA_MASSAGE: '스파·마사지',
      JAPANESE_CULTURAL_EXPERIENCE: '일본 문화 체험',
      JAPANESE_CRAFT_EXPERIENCE: '일본 공예 체험',
      JAPANESE_COOKING_EXPERIENCE: '일본 요리 만들기 체험',
      OTHER_EXPERIENCE: '기타 체험',
      HOTEL: '호텔',
      RYOKAN: '료칸',
      VACATION_RENTAL: '민박',
      BUNDLE: '세트',
      PASS: '패스',
      OTHERS: '기타'
    },
    possibleIntervalShow: {
      DAY: '{{amount}}일 이내',
      MONTH: '{{amount}}개월 이내'
    },
    voucherExpirationFromPurchase: {
      DAY: '구매일로부터 {{time}}일',
      MONTH: '구매일로부터 {{time}}개월',
      SAME_DAY: '구매일 당일'
    },
    voucherExpirationFromActivity: {
      DAY: '참가일로부터 {{time}}일간',
      MONTH: '참가일로부터 {{time}}개월간',
      SAME_DAY: '참가일 당일'
    }
  },
  week: {
    SUNDAY: '일요일',
    MONDAY: '월요일',
    TUESDAY: '화요일',
    WEDNESDAY: '수요일',
    THURSDAY: '목요일',
    FRIDAY: '금요일',
    SATURDAY: '토요일'
  },
  bankInfo: {
    swiftCode: 'SWIFT 코드',
    bankName: '은행명',
    bankCode: '은행 번호',
    bankBranchCode: '지점 코드',
    bankBranchName: '지점명',
    bankAddress: '은행 주소',
    bankAccountNumber: '계좌 번호',
    accountHolderName: '예금주명'
  },
  validation: {
    required: '{{name}}은 필수입니다',
    invalid: '유효한 {{name}}을 입력해 주세요',
    password: '영문 대소문자 및 기호 조합, 8자 이상으로 생성해 주세요',
    imageType: '이미지를 선택해 주세요',
    fileSize: '{{size}}MB 이하 파일을 선택해 주세요',
    range: '{{name}}은 {{min}}~{{max}} 범위로 입력해 주세요',
    greaterThan: '{{name}}은 {{min}}보다 큰 값을 입력해 주세요',
    notEqual: '{{name}}에 {{value}}는 입력할 수 없습니다',
    integer: '{{name}}은 정수로 입력해 주세요',
    requiredSelect: '선택해 주세요',
    alphabet: '영문 대문자로 입력해 주세요(공백 허용, 숫자 불가)',
    otaCustomIdFormat:
      '영문 대문자, 숫자, 밑줄로 1~16자, 첫 글자는 영문 대문자 또는 숫자로 입력해 주세요',
    maxLength: '{{name}}은 {{max}}자 이내로 입력해 주세요',
    personName: "{{name}}에 숫자·기호는 입력할 수 없습니다(' - . 는 사용 가능)",
    telFormat: '숫자, "+", "-"만 사용하여 8~20자로 입력해 주세요',
    flightNumber:
      '영문과 숫자를 모두 포함하여 반각 영숫자 3~8자로 입력해 주세요',
    dateNotBefore: '{{name}}은 {{min}} 이후의 날짜를 입력해 주세요',
    dateNotAfter: '{{name}}은 {{max}} 이전의 날짜를 입력해 주세요',
    passportName:
      "여권에 기재된 로마자(영문, 공백 및 ' - . 만)로 입력해 주세요",
    passportNumber: '반각 영숫자 6~12자로 입력해 주세요',
    ageMismatch: '생년월일로 계산한 나이({{age}}세)와 일치하지 않습니다'
  },
  messages: {
    newSuccess: '추가되었습니다',
    updateSuccess: '업데이트 완료',
    deleteSuccess: '삭제 완료',
    copySuccess: '복사',
    updateFailed: '업데이트에 실패했습니다',
    dateMax3Months: '날짜 범위는 3개월 이내로 지정해 주세요',
    downloadSuccess: '다운로드 완료되었습니다'
  },
  confirmDelete: {
    title: '확인해 주세요',
    prompt: '삭제하시겠습니까?'
  },
  autoLogout: {
    title: '곧 자동 로그아웃됩니다',
    description1:
      '보안을 위해 9시간 동안 조작이 없으면 자동으로 로그아웃됩니다.',
    description2: '계속 이용하시려면 「계속하기」를 클릭하세요.',
    logout: '지금 로그아웃',
    continue: '계속하기'
  },
  firebase: {
    'auth/invalid-credential':
      '로그인 이메일 또는 비밀번호가 올바르지 않습니다',
    'auth/email-already-in-use': '이 이메일 주소는 이미 등록되어 있습니다',
    'auth/too-many-requests':
      '로그인 시도 횟수가 초과되었습니다. 잠시 후 다시 시도하거나 비밀번호를 재설정해 주세요'
  },
  wallet: {
    feeRate: '수수료율',
    fee: '수수료',
    deductAmount: '합계금액',
    proceedToPayment: '동의 후 결제 진행',
    invalidAmount: '올바른 금액을 입력해 주세요'
  },
  transaction: {
    csvApplyDateTimezoneNote:
      '※주의: 정산 명세 CSV의 신청일은 여행 대리점의 로컬(브라우저) 시간이 아니라 주최사가 설정한 상품 시간대 기준이 적용됩니다.'
  },
  activityDetail: {
    title: '상품 상세',
    planTitle: '플랜 상세',
    faq: 'FAQ',
    location: '{{country}}',
    city: '・{{city}}',
    activity: {
      content: '상품 내용',
      api: 'API 코드',
      cancelPolicy: '취소 정책',
      productId: '상품 ID',
      operator: '공급사',
      timezone: '국가·지역 (시간대)',
      currency: '통화',
      language: '게시 언어',
      category: '카테고리',
      departure: '출발지',
      destination: '목적지',
      activityId: '액티비티 ID',
      activityName: '액티비티 이름',
      planId: '플랜 ID',
      planName: '플랜 이름',
      planStartTimeId: '플랜 시작 시간 ID',
      planStartTimeName: '플랜 시작 시간 이름',
      startTime: '시작 시간',
      planUnitItemsId: '플랜 단위 아이템 ID',
      planUnitName: '플랜 단위 이름'
    },
    plans: {
      description: '예약 정보',
      notes: '주의사항',
      schedule: '일정',
      locations: '장소',
      additionalBookingInfo: '추가 예약 정보',
      startTime: '시작 시간',
      noTimeLimit: '제한 없음',
      availableCount: '예약 가능 수',
      availableCountShow: '{{min}} ~ {{max}}',
      availablePeriod: '공개 기간',
      availablePeriodShow:
        '{{startY}}-{{startM}}-{{startD}} ~ {{endY}}-{{endM}}-{{endD}}',
      possibleInterval: '예약 가능 기간',
      reservationDeadline: '예약 접수 기한',
      reservationDeadlineShow: '참가일 {{day}}일 전 {{time}}까지 예약해 주세요',
      reservationDeadlineShowToday: '당일 {{time}}까지 예약해 주세요',
      voucherExpiration: '바우처 유효기간',
      voucherExpirationAnnualCutOff:
        '연도 증가 기준일: {{annualFixedDate}} 이전 구매분은 당해 상대 고정일 {{annualCutOffDate}}까지 만료되며, 연도 증가 기준일: {{annualFixedDate}} 이후 구매분은 익년 상대 고정일 {{annualCutOffDate}}까지 만료됩니다',
      optionalBookingFields: '대표자 정보(선택)',
      optionalExtendedBookingFields: '기타 정보(선택)',
      optionalParticipantFields: '이용자 정보※참가자별(선택)',
      requiredBookingFields: '대표자 정보(필수)',
      requiredExtendedBookingFields: '기타 정보(필수)',
      requiredParticipantFields: '이용자 정보※참가자별(필수)',
      customFields: '예약 정보 사용자 지정',
      customFieldsShow: '{{title}} : {{des}}',
      meetingPlace: '집합장소',
      dismissalPlace: '해산 장소',
      pickupPlace: '픽업 장소',
      dropOffPlace: '하차 장소'
    }
  }
};
